<template>
  <div class="o-toolbar">
    <div class="o-toolbar__left">
      <h2 class="c-heading-2">{{ klas.title }}</h2>
    </div>
  </div>

  <form @submit.prevent="onSubmit">
    <OrderOverzicht />
    <OrderTotaal />

    <footer class="c-container__footer">
      <div class="o-toolbar">
        <div class="o-toolbar__left">
          <button type="button" class="c-button c-button--default" @click="goBack">Terug</button>
        </div>
        <div class="o-toolbar__right">
          <button type="submit" class="c-button c-button--primary">Betaalformulier</button>
        </div>
      </div>
    </footer>
  </form>
</template>

<script>
import OrderOverzicht from "@/components/order/Overzicht";
import OrderTotaal from "@/components/order/Totaal";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { computed } from "vue";

export default {
  components: { OrderOverzicht, OrderTotaal },
  setup() {
    const router = useRouter();
    const store = useStore();

    const klas = computed(() => store.getters["data/findKlas"](store.state.orders.order.klasId));

    return {
      klas,
      goBack: () => router.push({ name: "cataloog", params: { klasId: klas.value.id } }),
      onSubmit: () => {
        router.push({ name: "betaalformulier" });
      },
    };
  },
};
</script>
